export default __webpack_public_path__ + "static/image-1-icon-f0c803e2bc9625808de1d2a3069cbef6.png";